import { createFileRoute, redirect } from '@tanstack/react-router';
import posthog from 'posthog-js';

import { medplum } from '@/config/medplum';
import { queryClient } from '@/config/queryClient';
import { logger } from '@/services/logger';

export const Route = createFileRoute('/(unauthenticated)/sign-out')({
  beforeLoad: async () => {
    try {
      await medplum.signOut();
    } catch (err) {
      logger.error('Sign out failed', err instanceof Error ? err : undefined, {
        component: 'SignOut',
      });
      posthog.captureException(err instanceof Error ? err : new Error('Sign out failed'), {
        component: 'SignOut',
      });
      medplum.clear();
    }
    queryClient.clear();

    throw redirect({ to: '/' });
  },
});
